import React, { useEffect, useState } from 'react';
import Helmet from 'react-helmet';
import { useMediaQuery } from 'react-responsive';
import { getAppEnv } from '../../../config/env';
import BreadCrumb from '../../components/BreadCrumb/BreadCrumb';
import DataLoaderError from '../../../server/errors/DataLoaderError';
import PageHeader from '../../components/PageHeader/PageHeader';
import AdsComponent from '../../components/adsComponent';
import CabModifySearch from '../../components/CabModifySearch/CabModifySearch';
import RentalCabs from '../../components/RentalCabs/RentalCabs';
import CompactList from '../../components/CompactList/CompactList';
import ThingsToKnow from '../../components/ThingsToKnow/ThingsToKnow';
import Footer from '../../components/Footer/Footer';
import FaqSection from '../../components/Faq/Faq';
import { RENTALS } from '../../constants/tripTypes';
import { EnvironmentVariables } from '../../types';
import AppContextProvider from '../../AppContext';
import { SEO_RENTAL_HOME_PAGE } from '../../constants/templateConstants';
import { trackRentalHomePageCabPageEvent } from '../../utils/omnitureTracking';
import './RentalHomePage.css';
import { HR_STRING } from '../../constants/miscellaneousConstants';
import capitalise from '../../utils/capitalise';
import HourlyRentalsCabs from '../../components/HourlyRentalsCabs/HourlyRentalsCabs';
import '../../pages/RouteCarTypeTemplate/RouteCarTypeTemplate.css';
import '../../components/ReadMore/ReadMore.css';
import '../CityOperatorTemplate/CityOperatorTemplate.css';
import '../../components/TopCabsRoutes/TopCabsRoutes.css';
import { RentalHomePageData } from './RentalHomePageDataChecker';
import { RentalHomePageTemplateData } from './RentalHomePageTemplateData';
import {
  fetchAndLogXdmEvent,
  useSearchWidgetHooks
} from '../../utils/commonUtils';

const env = getAppEnv();
const { DATA_LOADER_URL } = env.raw as EnvironmentVariables;
const HRCapitalized = capitalise(HR_STRING);

type RentalHomePageDataProp = {
  data: RentalHomePageData;
};

const RentalHomePage = ({ data }: RentalHomePageDataProp) => {
  const isMobileDevice = useMediaQuery({
    query: '(max-device-width: 768px)'
  });

  const [isOverlayVisible, setIsOverlayVisible] = useState(false);

  const toggleOverlay = (isVisible: boolean) => {
    setIsOverlayVisible(isVisible);
  };

  const {
    templateData,
    cabTypesAvailableForRent,
    hourlyRentalUrlsInOtherCities,
    randomPopularRoutes,
    randomPopularCities,
    rentalCabTypeModels,
    hrPackages
  } = data;
  const { travelFor, pickUpTime, dropTime } = useSearchWidgetHooks(
    SEO_RENTAL_HOME_PAGE
  );

  useEffect(() => {
    const url =
      typeof window !== 'undefined'
        ? window.location.href
        : templateData?.sampleUrl || '';
    fetchAndLogXdmEvent(url);
  }, []);

  return (
    <AppContextProvider
      omniUrlArgs={`source=${SEO_RENTAL_HOME_PAGE}`}
      trackTemplateEvent={trackRentalHomePageCabPageEvent}
    >
      <div className={`cabSeoDtPage`}>
        <Helmet>
          <title>{templateData.metaTitle}</title>
          <meta name="description" content={templateData.metaDescription} />
          <meta name="keywords" content={templateData.metaKeywords} />
          <link rel="canonical" href={templateData.sampleUrl} />
        </Helmet>
        <div className="infoForCrawler">
          <BreadCrumb breadcrumb={templateData.breadcrumb} />
          <PageHeader
            title={templateData.h1Title}
            extraInfo={templateData.extraInfo}
            isMobileDevice={isMobileDevice}
            isExtraInfoVisible={true}
          />
        </div>
        <div className={`domChanger mobileShow makeSticky`}>
          <CabModifySearch
            isOverlayVisible={isOverlayVisible}
            overlayToggle={toggleOverlay}
            pickupTime={pickUpTime}
            defaultTripType={travelFor}
            returnTime={dropTime}
            isMobileDevice={true}
            title={`Rental Cabs`}
            omniString={`_Rental_Home_Page`}
            hrPackages={hrPackages}
          />
        </div>

        <div className={`desktopShow makeSticky`}>
          <CabModifySearch
            pickupTime={pickUpTime}
            defaultTripType={travelFor}
            returnTime={dropTime}
            returnCloseFlagDefault={false}
            isMobileDevice={false}
            title={`Rental Cabs`}
            omniString={`_Rental_Home_Page`}
            hrPackages={hrPackages}
          />
        </div>
        <main className="container">
          <div style={{ display: 'none' }} className={'infoForUser'}>
            <BreadCrumb breadcrumb={templateData.breadcrumb} />
            <PageHeader
              title={templateData.h1Title}
              extraInfo={templateData.extraInfo}
              isMobileDevice={isMobileDevice}
              isExtraInfoVisible={true}
            />
          </div>
          <div className="appendBottom20">
            {/* {
              <AdsComponent
                template={'City'}
                placedAt={'top'}
                isMobileDevice={isMobileDevice}
                desktopAdConfig={{
                  position: templateData.bannerDesktop
                    ? templateData.bannerDesktop
                    : 'none',
                  class: 'desktopShow appendBottom20 adsLayout',
                  style: {}
                }}
                mobileAdConfig={{
                  position: templateData.bannerMobile
                    ? templateData.bannerMobile
                    : 'none',
                  class: 'mobileShow appendBottom20 adsLayout',
                  style: { marginTop: null }
                }}
              />
            } */}
          </div>
          {rentalCabTypeModels &&
            rentalCabTypeModels.packages &&
            rentalCabTypeModels.packages.length > 0 && (
              <HourlyRentalsCabs
                cityName={''}
                cabsAvailableForRent={rentalCabTypeModels}
                h2String={`Rentals Cabs`}
                showCityNameOnCabCard={true}
              />
            )}
          <RentalCabs
            h2={`Cab Prices`}
            cityName={''}
            data={cabTypesAvailableForRent}
          />
          <div
            style={{ flexWrap: 'wrap' }}
            className={`cabsSeoWrap__Details makeFlex visibilityAuto`}
          >
            {hourlyRentalUrlsInOtherCities &&
              hourlyRentalUrlsInOtherCities.length > 0 && (
                <CompactList
                  titlePrefix={`${HRCapitalized} Services in Other Cities `}
                  titleSuffix={``}
                  list={hourlyRentalUrlsInOtherCities}
                  type={'bullets'}
                  className={'rightMargin'}
                >
                  {(item: any, idx, style) => (
                    <li
                      key={`${item.name}_${idx}`}
                      className={`${
                        idx ? `paddingT10 paddingB10` : `paddingB10`
                      }`}
                    >
                      {item.url ? (
                        <a
                          className={`linkBoxFont `}
                          onClick={() => {
                            trackRentalHomePageCabPageEvent(
                              `Cab_SEO_${HRCapitalized} Services in Other Cities_Link_Click`
                            );
                          }}
                          href={item.url}
                        >
                          {`Rental Cabs in ${item.name}`}
                        </a>
                      ) : (
                        <span>{`Rental Cabs in ${item.name}`}</span>
                      )}
                    </li>
                  )}
                </CompactList>
              )}

            {randomPopularCities && randomPopularCities.length > 0 && (
              <CompactList
                titlePrefix={`Cabs Services in Other Cities`}
                titleSuffix={``}
                list={randomPopularCities}
                type={'bullets'}
                className={'rightMargin'}
              >
                {(item: any, idx, style) => (
                  <li
                    key={`${item.name}_${idx}`}
                    className={`${
                      idx ? `paddingT10 paddingB10` : `paddingB10`
                    }`}
                  >
                    {item.url ? (
                      <a
                        className={`linkBoxFont `}
                        onClick={() => {
                          trackRentalHomePageCabPageEvent(
                            `Cab_SEO_Popular Cabs in Other Cities_Link_Click`
                          );
                        }}
                        href={item.url}
                      >
                        {`Taxi services in ${item.name}`}
                      </a>
                    ) : (
                      <span>{`Taxi services in ${item.name}`}</span>
                    )}
                  </li>
                )}
              </CompactList>
            )}
            {randomPopularRoutes && randomPopularRoutes.length > 0 && (
              <CompactList
                titlePrefix={`Popular Cabs Services `}
                titleSuffix={``}
                list={randomPopularRoutes}
                type={'bullets'}
                className={''}
              >
                {(item: any, idx, style) => (
                  <li
                    key={`${item.name}_${idx}`}
                    className={`${
                      idx ? `paddingT10 paddingB10` : `paddingB10`
                    }`}
                  >
                    {item.url ? (
                      <a
                        className={`linkBoxFont`}
                        onClick={() => {
                          trackRentalHomePageCabPageEvent(
                            `Cab_SEO_Popular Route Cabs_Link_Click`
                          );
                        }}
                        href={item.url}
                      >
                        {`${item.sourceCityName} to ${item.destinationCityName} Cabs`}
                      </a>
                    ) : (
                      <span>{`${item.sourceCityName} to ${item.destinationCityName} Cabs`}</span>
                    )}
                  </li>
                )}
              </CompactList>
            )}
          </div>
          {templateData.descriptionInHtml ? (
            <section id="descriptionInHtml" className="visibilityAuto">
              <ThingsToKnow html={templateData.descriptionInHtml} />
            </section>
          ) : null}
          <section className="visibilityAuto">
            <h2>{`FAQs on Cab Rental Service`}</h2>
            <FaqSection
              trackTemplateEvent={trackRentalHomePageCabPageEvent}
              data={templateData.faq}
              pageUrl={templateData.sampleUrl}
              tripType={'HR'}
            />
          </section>
        </main>
        <>
          <Footer template={templateData} />
        </>
        {isOverlayVisible && (
          <div
            onClick={() => {
              toggleOverlay(false);
            }}
            className="searchWidgetModal mobileShow"
          ></div>
        )}
      </div>
    </AppContextProvider>
  );
};

RentalHomePage.fetchData = async (_, match, urlObj, gRPCClient) => {
  const urlString = `${DATA_LOADER_URL}/api/getCarRentalHomePage?refreshMode=static`;

  let responseData;
  const response = await fetch(urlString);
  const textResponse = await response.text();
  try {
    responseData = JSON.parse(textResponse);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('url', urlString);
    throw new Error('JSON parse exception: ' + textResponse);
  }
  if (responseData.status !== 'SUCCESS') {
    // eslint-disable-next-line no-console
    console.error('url', urlString);
    throw new DataLoaderError(`Unable to fetch bus list`, responseData.error);
  }
  const pathArray = urlObj.path.split('/');
  const cacheKey =
    'HTML_STATIC_' + pathArray[pathArray.length - 2].toUpperCase();

  // needs to be  in  a separate file or done differently,
  let templateData = RentalHomePageTemplateData;
  templateData = {
    ...templateData,
    footerData: responseData.footerData
  };
  return {
    pushToCache: true, // if this is set then after ssr it will be stored in cache
    cacheKey,
    ...responseData,
    templateData: templateData
  };
};

export default RentalHomePage;
